// Import static data (translations, etc)
import StaticData from '@/data/cms.json'

const translation = {
  install(Vue, options) {
    Vue.prototype.$getTrans = (string, lg, nested) => {
      let trans = ''
      let transStrLang = ''
      let transStrWord = ''
      let transStr = ''

      // console.log('getTrans')
      // console.log('string: ', string)
      // console.log('lg: ', lg)
      // console.log('nested: ', nested)

      if(!lg) {
        lg = 'de'
      }

      if(!string) {
        let trans = 'undefined'
      } else {
        if(nested) {
          // console.log('nested: ', nested)
          // console.log('string: ', string)

          let newNested = nested.split(".")

          // console.log('newNested: ', newNested)
          // console.log('newNested count: ', newNested.length)

          if(newNested.length === 1)
            trans = StaticData.translations[lg][nested][string]
          if(newNested.length === 2)
            trans = StaticData.translations[lg][newNested[0]][newNested[1]][string]
          if(newNested.length === 3)
            trans = StaticData.translations[lg][newNested[0]][newNested[1]][newNested[2]][string]
          if(newNested.length === 4)
            trans = StaticData.translations[lg][newNested[0]][newNested[1]][newNested[2]][newNested[3]][string]
          if(newNested.length === 5)
            trans = StaticData.translations[lg][newNested[0]][newNested[1]][newNested[2]][newNested[3]][newNested[4]][string]

          // console.log('trans: ', trans)
        } else {
            trans = StaticData.translations[lg][string]
        }
      }
      // console.log('trans: ', trans)

      return trans
    }
  }
};

// Usage example:
// {{ $getTrans('home', 'de') }}
export default translation;



// WEBPACK FOOTER //
// ./src/plugins/translation.js